import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { GridComponent } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { ChecklistService } from 'src/app/Service/checklist/checklist.service';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ChecklistItemModel } from 'src/app/ViewModel/ChecklistItemModel';


const createFormGroup = (dataItem: { clDescription: any; clId: any; cliDescription: any; cliId: any; cliShortDescription: any; dependentCLIDescription: any; dependentCLIId: any; isActive: any; isCheck: any; isMandatory: any; revisionNo: any; sortOrder: any; createdBy?: number; dependentCliList: any; }) => new FormGroup({
	'clDescription': new FormControl(dataItem.clDescription),
	'clId': new FormControl(dataItem.clId),
	'cliDescription': new FormControl(dataItem.cliDescription),
	'cliId': new FormControl(dataItem.cliId),
	'cliShortDescription': new FormControl(dataItem.cliShortDescription),
	'dependentCLIDescription': new FormControl(dataItem.dependentCLIDescription),
	'dependentCLIId': new FormControl(dataItem.dependentCLIId),
	'isActive': new FormControl(dataItem.isActive),
	'isCheck': new FormControl(dataItem.isCheck),
	'isMandatory': new FormControl(dataItem.isMandatory),
	'sortOrder': new FormControl(dataItem.sortOrder),
	'revisionNo': new FormControl(dataItem.revisionNo),
	'dependentCliList': new FormControl(dataItem.dependentCliList),
});

@Component({
	selector: 'app-checklist-item',
	templateUrl: './checklist-item.component.html',
	styleUrls: ['./checklist-item.component.css']
})

export class ChecklistItemComponent implements OnInit {


	@ViewChild(GridComponent)
	private grid!: GridComponent;

	@Input() checklistName!: string;
	@Output() response = new EventEmitter();

	enableChkLstItemFilter = false;
	checklistItemList: ChecklistItemModel[] = [];

	checklistId!: number;
	isNew = false;
	editedRowIndex:number | any ;
	isNewRow = false;
	public formGroup: FormGroup | any;

	sortOrderArr: number[] = [];
	dependentCliList: {
		dependentCLIDescription: string,
		dependentCLIId: number
	}[] = [];

	constructor(
		public checklistService: ChecklistService,
		public commonService: CommonService,
		public notificationService: NotificationService,
	) {

	}

	ngOnInit() {
		this.checklistService.checklistId.subscribe(data => {
			if (data) {
				this.checklistId = data;
				this.getChecklistItem();
			} else {
				this.checklistItemList = [];
			}
		});
	}

	getChecklistItem() {
		this.checklistService.getChecklistItem(this.checklistId).subscribe(data => {
			this.checklistItemList = data;
			this.sortOrderArr = [];
			data.forEach(each => {
				this.sortOrderArr.push(each.sortOrder);
			});
			this.sortOrderArr.sort();

			if (this.checklistItemList.length) {
				this.setDependentCliList();
			}
		});
	}

	setDependentCliList() {
		this.dependentCliList = [];
		this.checklistItemList.forEach(each => {
			let newDependentCli = {
				'dependentCLIDescription': each.cliDescription,
				'dependentCLIId': each.cliId,
			}
			this.dependentCliList.push(newDependentCli);
		});

		this.checklistItemList.forEach(each => {
			each['dependentCliList'] = this.dependentCliList.filter(eachFilter => eachFilter.dependentCLIId != each.cliId);
		});
	}

	emit() {
		this.response.emit("");
	}

	changeDependentCli(event: { value: string; text: any; }) {
		if (event.value != '-2') {
			this.formGroup.get('dependentCLIId').setValue(event.value);
			this.formGroup.get('dependentCLIDescription').setValue(event.text);
		} else {
			this.formGroup.get('dependentCLIId').setValue(null);
			this.formGroup.get('dependentCLIDescription').setValue('');
		}
	}

	changeActiveStatus(event: MatCheckboxChange) {
		this.formGroup.get('isActive').setValue(event.checked);
	}

	changeIsCheck(event: MatCheckboxChange) {
		this.formGroup.get('isCheck').setValue(event.checked);
	}

	changeIsMandatory(event: MatCheckboxChange) {
		this.formGroup.get('isMandatory').setValue(event.checked);
	}

	editRowData({ sender, rowIndex, dataItem }:any) {

		//closing previous row, if anything opened
		if (this.editedRowIndex >= 0) {
			sender.closeRow(this.editedRowIndex);
		}

		let selectedRowSortOrder = dataItem.sortOrder;
		let index = this.sortOrderArr.indexOf(selectedRowSortOrder);
		if (index > -1) {
			this.sortOrderArr.splice(index, 1);
		}

		this.editedRowIndex = rowIndex;
		this.formGroup = createFormGroup(dataItem);
		this.isNewRow = false;
		sender.editRow(rowIndex);
	}

	UpdateRowData({ sender, rowIndex, dataItem } : any) {
		dataItem = this.formGroup.value;

		if (!dataItem.cliDescription) {
			this.notificationService.showToast('Enter checklist item name', 'Warning');
			return;
		}

		if (!dataItem.sortOrder) {
			this.notificationService.showToast('Enter sort order', 'Warning');
			return;
		}

		if (this.sortOrderArr.includes(dataItem.sortOrder)) {
			this.notificationService.showToast('Sort order already exists', 'Warning');
			return;
		}

		this.saveChecklistItem();
		this.isNewRow = false;
		sender.closeRow(rowIndex);
	}

	cancelRowData({ sender, rowIndex, dataItem }:any) {
		this.isNewRow = false;
		sender.closeRow(rowIndex);
		this.getChecklistItem();
	}

	addHandler() {

		this.isNewRow = true;
		this.closeEditor();

		let newSortOrderDefaultValue = this.checklistItemList.length ? (this.checklistItemList.length + 1) : 1;

		this.formGroup = createFormGroup({
			clDescription: '',
			clId: this.checklistId,
			cliDescription: '',
			cliId: null,
			cliShortDescription: '',
			dependentCLIDescription: '',
			dependentCLIId: null,
			isActive: true,
			isCheck: false,
			isMandatory: false,
			revisionNo: null,
			sortOrder: newSortOrderDefaultValue,
			createdBy: this.commonService.getLoggedInUserId(),
			dependentCliList: this.dependentCliList
		});
		this.isNew = true;
		this.grid.addRow(this.formGroup);
	}

	public cellClickHandler({ isEdited, dataItem, rowIndex }:any): void {

		if (isEdited) {
			return;
		}
		this.formGroup = createFormGroup(dataItem);
		this.editedRowIndex = rowIndex;
		this.grid.editRow(rowIndex, this.formGroup);
	}


	public cancelHandler(): void {
		this.closeEditor();
	}

	private closeEditor(): void {
		this.grid.closeRow(this.editedRowIndex);

		this.isNew = false;
		this.editedRowIndex = undefined;
		this.formGroup = undefined;
	}

	saveChecklistItem() {
		let newChecklistItem: ChecklistItemModel = this.formGroup.value;

		// revision number as 1, by default for new checklist item
		if (this.isNewRow) {
			newChecklistItem.revisionNo = 1;
		}
		newChecklistItem.createdBy = this.commonService.getLoggedInUserId();
		this.checklistService.postChecklistItem(newChecklistItem).subscribe(data => {
			this.notificationService.handleResponse(data);
			this.getChecklistItem();
		});
	}
}
